import React, { useEffect, useState } from "react";
import SpecialtiesDetailBanner from "../../../components/SpecailitiesComponents/SpecialitiesDetailBanner";
import CauseImage from "../../../components/ServiceComponents/CausesSection/CauseImage";
import MeetOurExperts from "../../../components/MainComponents/MeetOurExperts";
import Footer from "../../../components/MainComponents/Footer";
import WhatDoesSection from "../../../components/SpecailitiesComponents/WhatDoesSection";
import withAnimation from "../../../hooks/withAnimation";
import RelatedConditions from "../../../components/MainComponents/RelatedConditions";
import Header from "../../../components/MainComponents/Header";
import SpecialtiesSymptoms from "../../../components/SpecailitiesComponents/SpecialitiesSymptoms";
import { getSpecById } from "../../../utils/Data";
import { useParams } from "react-router-dom";
import ServiceBanner from "../../../components/ServiceComponents/ServiceBanner";
import ServiceList from "../../../components/MainComponents/ServiceList";
import BookAppointmentSection from "../../../components/HomeComponents/BookAppointmentSection";
import FeatureSection from "../../../components/HomeComponents/FeatureSection";
import ContactSection from "../../../components/ContactComponents/ContactSection";
import ContactHeader from "../../../components/MainComponents/ContactHeader";

const SpecialitiesDetail = () => {
  const { specialitiesId } = useParams();
  const [specailitiesData, setspecailitiesData] = useState(null);

  useEffect(() => {
    const specData = getSpecById(specialitiesId);
    setspecailitiesData(specData);
  }, [specialitiesId]);

  if (!specailitiesData) {
    return <div>Loading...</div>;
  }

  const defaultDescription =
    "Low back pain (LBP) is a common experience in people of all age groups. Postural LBP is usually caused by abnormal loading on the muscles, ligaments, and joints, which leads to pain and discomfort over time. Based on duration, LBP is classified into acute, sub-acute, and chronic types, depending on how long the pain persists.";

  return (
    <div>
       <ContactHeader/>
      <Header />
     
      <ServiceBanner image={specailitiesData.image} title={specailitiesData?.title || "Default Title"} description = {specailitiesData?.description || defaultDescription}/>
      
      
      <ServiceList/>
      
        <BookAppointmentSection mainImage = {specailitiesData.imageTwo}/>
        {/* <HealingStories/> */}
        <WhatDoesSection
        imageUrl={specailitiesData.howItWorks?.image}
        title={specailitiesData?.title || "Default Title"}
        mainDescription={specailitiesData?.howItWorks?.description || defaultDescription}
      />
       

        <SpecialtiesSymptoms mainImage = {specailitiesData.imageTwo} causes={specailitiesData?.symptoms || []} />
        <FeatureSection/>
      
      {/* <RelatedConditions conditions={specailitiesData?.relatedConditions || []} /> */}
      {/* <MeetOurExperts /> */}
      <ContactSection/>
      <Footer />
    </div>
  );
};

export default withAnimation(SpecialitiesDetail);